import { DateFormat } from '../date/client';
import { transformDate } from '../date/utils/transformDate';

import { IUserNote } from './client';
import { UserNoteServer } from './server';

export const normalizeUserNote = (raw: UserNoteServer): IUserNote => {
  return {
    id: raw._id,
    text: raw.text,
    dateCreated: raw.date_created,
    dateUpdated: raw.date_updated,
    dateUpdatedFormatted: transformDate(
      new Date(raw.date_updated),
      DateFormat.dayMonthYearTimeWithSec
    ),
    managerId: raw.manager_id,
    managerName: raw.manager_name,
    mentionedManagerIds: raw.mentioned_manager_ids ?? []
  };
};
